import { ColumnDef } from "@tanstack/react-table"

import type { ConnectionType } from "@/types"

import { DataTableColumnHeader } from "../../data-table"
import { ConnectionTypesOperations } from "../operations/connection-types-operation"

export const connectionTypesColumn: ColumnDef<ConnectionType>[] = [
  {
    accessorKey: "type_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.type_name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "sequence",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sequence" />
    ),
    cell: ({ row }) => {
      const value = row.original.sequence
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "icon",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Icon" />
    ),
    cell: ({ row }) => {
      const value = row.original.icon
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <ConnectionTypesOperations data={row.original} />
        </div>
      )
    },
  },
]
